import axios, { AxiosResponse, AxiosError } from "axios";
import { toast } from "react-toastify";

const uri =
  process.env.NODE_ENV == "development"
    ? process.env.REACT_APP_DEV_URL
    : process.env.REACT_APP_URL;


const instance = axios.create({
  baseURL: uri,
});

// Add response interceptor to handle token expiration
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    // Handle 401 Unauthorized errors (token expired)
    if (error.response && error.response.status === 401) {
      // Clear auth tokens from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("refToken");
      
      // Show notification to user
      toast.error("Your session has expired. Please login again.");
      
      // Redirect to login page
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// const responseBody = (response: AxiosResponse) => response.data;

export const call = {
  get: async (url: string,headers:any) =>  await instance.get(url,headers),
  post: async (url: string, body: any,headers:any) => await instance.post(url, body,headers),
  put: async (url: string, body: any,headers:any) => await instance.put(url, body,headers),
  delete: async (url: string,headers:any) => await instance.delete(url,headers),
};
